/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {

      let thumbs = document.querySelectorAll('.media__thumb[data-variants]');

      if (thumbs) {
        thumbs.forEach(function (thumb) {
          if (thumb.dataset.variants != '000') {
            let variants = thumb.dataset.variants.split(',');
            console.log(variants);
            if (variants.includes(variant.id.toString())) {
              thumb.style.display = 'inline-block';
            } else {
              thumb.style.display = 'none';
            }
          } else {
            thumb.style.display = 'inline-block';
          }
        });
      }

      // ... update some element on the page
    }
  });

  /*document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });*/
  // Fired when page loads to update header values
  //document.addEventListener('theme:cart:init', (e) => {
  //  console.log('theme:cart:init');
  //  console.log(e);
  //});

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  //document.addEventListener('theme:scroll', e => { console.log(e); });
  //document.addEventListener('theme:scroll:up', e => { console.log(e); });
  //document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
